var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.08594,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 1.5,
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50587 3.96181C9.9327 3.5147 10.7547 3.82829 10.6817 4.4104L10.2633 7.74798C10.2589 7.78311 10.29 7.81384 10.3299 7.81384H14.1655C14.7352 7.81384 15.0443 8.40453 14.6763 8.79L9.666 14.0382C9.23917 14.4853 8.41715 14.1717 8.49013 13.5896L8.90855 10.252C8.91295 10.2169 8.88191 10.1861 8.84201 10.1861H5.00637C4.43668 10.1861 4.12757 9.5954 4.49555 9.21L9.50587 3.96181Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.65d91b133b8fdd8369178ed67fa7826e.svg";
export { ForwardRef as ReactComponent };